// icb.component.ts
import { Component } from '@angular/core';
import { Links } from './links';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { CommonService } from '../shared/services/common.service';
import { SessionHandler } from '../shared/services/session-handler.service';
import { HttpService } from '../shared/services/http.service';
import { MdDialog } from '@angular/material';
import { dialogComponent } from '../dialog/dialog.component';
import { TranslateService } from 'ng2-translate';
import { Location } from '@angular/common';

@Component({
  template: require('./icb.component.html'),
  styles: [require('./icb.component.scss')]
})
export class IcbComponent {
  data: any = [];
  dialogRef: any;
  id: any;
  headLineKey: string; // store translation key
  navLinks: Links[] = [];
  userData: any;
  orderId: any;
  isApprover: boolean = false;

  constructor(
    private router: Router,
    private commonService: CommonService,
    private route: ActivatedRoute,
    private sessionHandler: SessionHandler,
    private http: HttpService,
    private dialog: MdDialog,
    private translate: TranslateService,
    private location: Location
  ) {
    // configure available languages depending on country
    let country = this.sessionHandler.getItem('country');
    if (country === 'BE') {
      translate.addLangs(['English', 'French', 'German', 'Dutch']);
    } else if (country === 'NL') {
      translate.addLangs(['English', 'Dutch']);
    } else if (country === 'FR') {
      translate.addLangs(['English', 'French']);
    } else if (country === 'DE') {
      translate.addLangs(['English', 'German']);
    }

    // choose default/saved language
    let defaultLanguage = this.sessionHandler.getItem('defaultLanguage');
    if (defaultLanguage) {
      try {
        translate.use(defaultLanguage);
      } catch (e) {
        translate.setDefaultLang('English');
        translate.use('English');
      }
    } else {
      translate.setDefaultLang('English');
      translate.use('English');
    }

    // keep component updated when global language changes
    this.commonService.langChange.subscribe((value: string) => {
      if (value) {
        try {
          this.translate.use(value);
        } catch (e) {
          console.warn('translate.use failed for', value, e);
        }
      }
    });

    this.userData = JSON.parse(this.sessionHandler.getItem('loginData'));

    // listen for navigation changes and set headline/nav using translation keys
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      const url: string = evt['url'] || '';

      if (url.indexOf('icb/consumer') > -1) {
        // set translation keys (template should use | translate)
        this.headLineKey = 'technical_request'; // key in your i18n files
        this.setlinks('consumer');
      } else if (url.indexOf('icb/trade') > -1) {
        this.headLineKey = 'trade_details_label'; // key in your i18n files
        this.setlinks('trade');
      } else if (url.indexOf('icb/detail') > -1) {
        this.headLineKey = 'trade_details_label';
        this.navLinks = [];
      } else {
        this.navLinks = [];
      }
    });
  }

  /**
   * Set navigation links using translation keys, not literal English text.
   * The template already uses the translate pipe for link.name and link.sub_heading.
   *
   * Ensure the translation JSONs contain the keys used below:
   *  - 'appliance_details_label'
   *  - 'pickup_details_label'
   *  - 'summary'
   *  - 'please_verify_personal_data'
   *  - 'confirmation'
   *  - 'response_message'
   *
   * If your JSON uses different keys rename them here to match.
   */
  public setlinks(page: string) {
    const base = page === 'consumer' ? 'consumer' : 'trade';

    this.navLinks = [
      new Links('1', 'appliance_details_label', 'pickup_details_label', `${base}/data/`),
      new Links('2', 'summary', 'please_verify_personal_data', `${base}/summary/`),
      new Links('3', 'confirmation', 'response_message', `${base}/confirm/`)
    ];
  }

  back() {
    this.location.back();
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/icb/icb.component.ts